import type { DailyStatusCode } from "./types";

export const DAILY_STATUS_CODES: DailyStatusCode[] = ["8", "4", "В", "О", "Б", "А", "К", "Р", "П"];

export const DEFAULT_EDIT_NOTE = "Manual edit";
